import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const PrivacyPolicy = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-white" data-testid="privacy-policy-page">
      <Header />

      <div className="pt-24 pb-20">
        <div className="max-w-4xl mx-auto px-6 lg:px-16">
          <Link to="/" className="inline-flex items-center text-[#002FA7] hover:text-[#001D66] mb-6 transition-colors text-sm font-medium">
            <ArrowLeft className="w-4 h-4 mr-1" /> Home
          </Link>

          <h1 className="text-4xl font-black text-[#09090B] mb-6" style={{fontFamily:'Outfit,sans-serif'}}>Privacy Policy</h1>

          <div className="prose max-w-none space-y-6 text-zinc-600">
            <p className="text-base leading-relaxed">
              At <strong className="text-[#09090B]">Trademark My Logo Name</strong>, we are committed to protecting your privacy and ensuring that your personal information is handled in a safe and responsible manner. This Privacy Policy outlines how we collect, use, and protect your personal data, and it applies to all interactions with our website, products, and services.
            </p>

            <section>
              <h2 className="text-xl font-bold text-[#09090B] mt-8 mb-4" style={{fontFamily:'Outfit,sans-serif'}}>Information We Collect</h2>
              <p>We collect personal information from you when you visit our website, register for an account, make a purchase, or communicate with us. The types of information we may collect include:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong className="text-zinc-800">Personal Identification Information:</strong> Name, email address, phone number, billing and shipping addresses, and payment information.</li>
                <li><strong className="text-zinc-800">Non-personal Identification Information:</strong> IP address, browser type, operating system, and website usage information.</li>
                <li><strong className="text-zinc-800">Cookies and Tracking Technologies:</strong> We use cookies and similar tracking technologies to enhance your browsing experience, analyze website traffic, and personalize content.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#09090B] mt-8 mb-4" style={{fontFamily:'Outfit,sans-serif'}}>How We Use Your Information</h2>
              <p>We use the information we collect for various purposes, including:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>To process and manage your transactions and orders.</li>
                <li>To communicate with you about your orders, services, or updates.</li>
                <li>To respond to your inquiries and provide customer support.</li>
                <li>To improve our website, products, and services.</li>
                <li>To send promotional materials, newsletters, and other marketing communications (if you have opted-in).</li>
                <li>To prevent fraud and ensure the security of our website.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#09090B] mt-8 mb-4" style={{fontFamily:'Outfit,sans-serif'}}>How We Protect Your Information</h2>
              <p>We implement a variety of security measures to maintain the safety of your personal information, including:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong className="text-zinc-800">Encryption:</strong> We use SSL encryption technology to protect sensitive data during transmission.</li>
                <li><strong className="text-zinc-800">Secure Storage:</strong> Your personal information is stored in a secure environment with restricted access.</li>
                <li><strong className="text-zinc-800">Regular Audits:</strong> We regularly review our security practices to ensure that your data is safeguarded.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#09090B] mt-8 mb-4" style={{fontFamily:'Outfit,sans-serif'}}>Sharing Your Information</h2>
              <p>We do not sell, trade, or otherwise transfer your personal information to third parties, except in the following cases:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong className="text-zinc-800">Service Providers:</strong> We may share your data with trusted third-party service providers who assist us in operating our website, processing payments, or providing customer service.</li>
                <li><strong className="text-zinc-800">Legal Compliance:</strong> We may disclose your information to comply with legal obligations, enforce our site policies, or protect our rights or the rights of others.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#09090B] mt-8 mb-4" style={{fontFamily:'Outfit,sans-serif'}}>Your Rights and Choices</h2>
              <p>You have the following rights regarding your personal information:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong className="text-zinc-800">Access and Correction:</strong> You may request access to your personal information and request corrections or updates.</li>
                <li><strong className="text-zinc-800">Opt-Out:</strong> If you no longer wish to receive marketing communications, you can opt-out by clicking the unsubscribe link in any email.</li>
                <li><strong className="text-zinc-800">Deletion:</strong> You may request that we delete your personal information, subject to applicable legal obligations.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#09090B] mt-8 mb-4" style={{fontFamily:'Outfit,sans-serif'}}>Contact Us</h2>
              <p>If you have any questions about this Privacy Policy, please contact us at:</p>
              <div className="bg-[#F4F4F5] border border-zinc-200 p-6 rounded-lg mt-4">
                <p><strong className="text-zinc-800">Company:</strong> Trademark My Logo Name</p>
                <p><strong className="text-zinc-800">Address:</strong> 515 Flower St, Los Angeles, CA 90071, United States</p>
                <p><strong className="text-zinc-800">Phone:</strong> (800) 555-1234</p>
                <p><strong className="text-zinc-800">Email:</strong> info@trademarkmylogoname.com</p>
              </div>
            </section>

            <p className="text-sm text-zinc-400 mt-8 pt-8 border-t border-zinc-200">
              <strong>Effective Date:</strong> January 1, 2025
            </p>

            <p className="mt-4">By using our website and services, you consent to the terms of this Privacy Policy.</p>
          </div>
        </div>
      </div>

      <Footer onOpenContactForm={() => {}} />
    </div>
  );
};

export default PrivacyPolicy;
